"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
function AdvantagesItem(props) {
    return (react_1.default.createElement("div", { className: props.className },
        props.children[0],
        react_1.default.createElement("div", { className: "info" }, props.children.slice(1))));
}
var SAdvantagesItem = (0, styled_components_1.default)(AdvantagesItem)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-basis: 30%;\n    align-items: center;\n    margin-bottom: 60px;\n\n    img {\n        width: 88px;\n        height: 88px;\n        margin-right: 24px;\n    }\n\n    .info {\n        height: 100%;\n    }\n\n\n    @media (max-width: 480px) {\n        flex-basis: 100%;\n    }\n"], ["\n    display: flex;\n    flex-basis: 30%;\n    align-items: center;\n    margin-bottom: 60px;\n\n    img {\n        width: 88px;\n        height: 88px;\n        margin-right: 24px;\n    }\n\n    .info {\n        height: 100%;\n    }\n\n\n    @media (max-width: 480px) {\n        flex-basis: 100%;\n    }\n"])));
exports.default = SAdvantagesItem;
var templateObject_1;
